import React, { useState } from "react";
import MasterLayout from "../Sections/MasterLayout";

export default function Settings() {
  const [operationStart, setOperationStart] = useState("06:00");
  const [operationEnd, setOperationEnd] = useState("22:00");
  const [emergencyAlert, setEmergencyAlert] = useState("");

  const handleSave = (e) => {
    e.preventDefault();
    const payload = {
      operationStart,
      operationEnd,
      emergencyAlert,
    };

    // You can integrate API logic here
    console.log("Saving Settings:", payload);
    alert("Settings saved successfully!");
  };

  return (
    <MasterLayout>
      <div className="w-full space-y-6">
        {/* Header */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 w-full">
          <h1 className="text-2xl font-bold text-gray-900">
            Settings & Configuration
          </h1>
          <p className="text-sm text-gray-600 mt-1">
            Manage metro operation hours and emergency announcements
          </p>
        </div>

        {/* Form */}
        <form
          onSubmit={handleSave}
          className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 space-y-6"
        >
          {/* Operation Timings */}
          <div>
            <h2 className="text-lg font-semibold text-gray-800 mb-4">
              Metro Operation Timings
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Start Time
                </label>
                <input
                  type="time"
                  value={operationStart}
                  onChange={(e) => setOperationStart(e.target.value)}
                  className="w-full border rounded-md p-2 text-gray-700"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  End Time
                </label>
                <input
                  type="time"
                  value={operationEnd}
                  onChange={(e) => setOperationEnd(e.target.value)}
                  className="w-full border rounded-md p-2 text-gray-700"
                />
              </div>
            </div>
          </div>

          {/* Emergency Alert */}
          <div>
            <h2 className="text-lg font-semibold text-gray-800 mb-4">
              Emergency Alert
            </h2>
            <textarea
              rows="4"
              value={emergencyAlert}
              onChange={(e) => setEmergencyAlert(e.target.value)}
              placeholder="Write emergency announcement or leave blank"
              className="w-full border rounded-md p-3 text-gray-700"
            ></textarea>
            <p className="text-xs text-gray-500 mt-1">
              This alert will be shown in the mobile app if filled.
            </p>
          </div>

          {/* Save Button */}
          <div className="flex justify-end">
            <button
              type="submit"
              className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition"
            >
              Save Settings
            </button>
          </div>
        </form>
      </div>
    </MasterLayout>
  );
}
